<template>
  <div class="container mt-4 border">
    <div class="d-flex align-items-center justify-content-between">
      <div style="font-size: 18px; font-weight: bold;">Groups</div>

      <!-- Toolbar: ค้นหา / size / รีเฟรช -->
      <div class="d-flex align-items-center gap-2 mt-2 flex-nowrap" style="overflow:auto; white-space: nowrap;">
        <input
          v-model.trim="q"
          @keyup.enter="reload"
          type="search"
          class="form-control"
          placeholder="ค้นหาชื่อกลุ่ม (กด Enter)"
          style="max-width: 260px; min-width: 200px;"
        />
        <select v-model.number="size" class="form-select" style="width: 120px;">
          <option :value="10">10 / หน้า</option>
          <option :value="20">20 / หน้า</option>
          <option :value="50">50 / หน้า</option>
        </select>
        <button class="btn btn-outline-primary" :disabled="loading" @click="reload">
          {{ loading ? "กำลังโหลด..." : "รีเฟรช" }}
        </button>
      </div>
    </div>

    <table class="table table-bordered table-striped mt-3">
      <thead class="mt-2">
        <tr>
          <th>No</th>
          <th style="min-width: 220px;">name</th>
          <th>description</th>
          <th style="width: 120px;">PlansALL</th>
          <th style="width: 120px;">Members</th>
          <th >Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="6" class="text-center text-muted py-4">กำลังโหลดข้อมูล...</td>
        </tr>
        <tr v-else-if="list_group.length === 0">
          <td colspan="6" class="text-center text-muted py-4">ไม่พบข้อมูล</td>
        </tr>

        <tr v-else v-for="(itemgroup, index) in list_group" :key="itemgroup.id || index">
          <td class="text-center">{{ index+1 }}</td>
          <!-- <td>{{ itemgroup.id }}</td> -->
          <td>{{ itemgroup.name }}</td>
          <td>{{ itemgroup.description || "-" }}</td>
          <td>{{ itemgroup.planall }}</td>
          

          <td class="text-center">
            <router-link
              class="btn text-white py-1 px-2 rounded-4"
              style="background-color: rgb(47, 144, 220); font-size: 14px;"
              :to="{ name:'group-plan', params:{ id:itemgroup.id, name: encodeURIComponent(itemgroup.name||'') } }">
              plan
            </router-link>

            <router-link
              class="btn text-white py-1 px-2 rounded-4 ms-1"
              style="background-color: rgb(47, 144, 220); font-size: 14px;"
              :to="{ name:'group-user', params:{ id:itemgroup.id, name: encodeURIComponent(itemgroup.name||'') } }">
              user
            </router-link>
          </td>
          <td class="text-center">
            <button @click="group=itemgroup" type="button" class="btn text-white py-1 px-2 rounded-4"
              data-bs-toggle="modal" data-bs-target="#editGroupModal"
              style="background-color: rgb(47, 144, 220); font-size: 14px;">
              <font-awesome-icon :icon="['fas', 'pen']" /> Edit
            </button>
            <button @click="deleteGroup(itemgroup.id)" type="button"
              class="btn btn-danger text-white py-0 ms-1 py-1 px-2 rounded-4" style="font-size: 14px;">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <div class="d-flex justify-content-between align-items-center mt-2 mb-4">
      <div class="text-muted">
        ทั้งหมด: {{ total }} รายการ
      </div>
      <div class="btn-group">
        <button class="btn btn-outline-secondary" :disabled="page <= 1 || loading" @click="prevPage">ก่อนหน้า</button>
        <span class="btn btn-outline-secondary disabled">หน้า {{ page }}</span>
        <button class="btn btn-outline-secondary" :disabled="disableNext || loading" @click="nextPage">ถัดไป</button>
      </div>
    </div>

    <!-- Edit Group Modal -->
    <div class="modal fade" id="editGroupModal" tabindex="-1" aria-labelledby="editGroupModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editGroupModalLabel">Edit Group</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="container">
              <div class="row">
                <!-- Left -->
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label"><i class="bi bi-envelope"></i> Group name</label>
                    <input type="text" class="form-control" placeholder="Name" v-model="group.name" />
                  </div>
                  <div class="mb-3">
                    <label class="form-label"><i class="bi bi-envelope"></i> planall</label>
                    <select class="form-select" v-model="group.planall">
                      <option :value="true">true</option>
                      <option :value="false">false</option>
                    </select>
                  </div>
                  
                </div>

                <!-- Right -->
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label"><i class="bi bi-bookmark"></i> Description</label>
                    <textarea class="form-control" rows="4" placeholder="Description..." v-model="group.description"></textarea>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-between mt-4">
                <button class="btn btn-danger px-4" @click="clearForm">
                  <i class="bi bi-brush"></i> Clear
                </button>
                <button class="btn btn-secondary px-4" @click="editGroup(group.id)">
                  <i class="bi bi-save"></i> Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- /Modal -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // ตาราง
      list_group: [],
      loading: false,
      q: "",
      page: 1,
      size: 10,
      total: 0,

      // modal edit group
      group: { },
    };
  },
  computed: {
    disableNext() {
      return this.page * this.size >= this.total;
    },
  },
  methods: {
    /* ---------- API helpers ---------- */
    authHeaders(json = true) {
      const token = localStorage.getItem("accessToken");
      const h = json ? { "Content-Type": "application/json" } : {};
      return token ? { ...h, Authorization: `Bearer ${token}` } : h;
    },

    /* ---------- Groups list ---------- */
    async getAllDevice() {
      try {
        this.loading = true;
        const params = new URLSearchParams({
          ...(this.q ? { q: this.q } : {}),
          page: String(this.page),
          size: String(this.size),
        });
        const res = await fetch(`${process.env.VUE_APP_API_URL}/api/groups?` + params.toString(), {
          method: "GET",
          headers: this.authHeaders(false),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();

        // map ฟิลด์ให้ตรง + fallback
        const rows = Array.isArray(json?.data) ? json.data : [];
        this.list_group = rows.map((g) => ({
          ...g,
          planall: g.planall ?? g.plansCount ?? 0,
          member: g.member ?? g.usersCount ?? 0,
          description: g.description ?? "",
        }));
        this.total = json?.meta?.total ?? this.list_group.length;
      } catch (e) {
        console.error("Error fetching groups:", e);
        this.list_group = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    reload() {
      this.page = 1;
      this.getAllDevice();
    },
    nextPage() {
      if (!this.disableNext) {
        this.page += 1;
        this.getAllDevice();
      }
    },
    prevPage() {
      if (this.page > 1) {
        this.page -= 1;
        this.getAllDevice();
      }
    },

    /* ---------- Edit Group modal ---------- */
    openEdit(row) {
      const clone = (o) => JSON.parse(JSON.stringify(o ?? {}));
      this.group = clone({
        id: row.id,
        name: row.name || "",
        description: row.description || "",
      });
    },
    async editGroup(id) {
      try {
        // ปรับ endpoint ให้ตรง backend ของคุณ เช่น PUT /api/groups/:id
        const res = await fetch(`${process.env.VUE_APP_API_URL}/api/group/${id}`, {
          method: "PUT",
          headers: this.authHeaders(true),
          body: JSON.stringify({
            name: this.group.name,
            planall: this.group.planall,
            description: this.group.description,
          }),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        await res.json();

        // รีโหลดตาราง
        this.getAllDevice();
      } catch (e) {
        console.error("Error edit group:", e);
      }
    },
    async deleteGroup(id) {
      try {
        if (!confirm("แน่ใจหรือไม่ว่าต้องการลบกลุ่มนี้?")) return;
        // ปรับให้ตรง backend เช่น DELETE /api/groups/:id หรือ /api/groups?groupid=
        const res = await fetch(`${process.env.VUE_APP_API_URL}/api/group/${id}`, {
          method: "DELETE",
          headers: this.authHeaders(false),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        this.getAllDevice();
      } catch (e) {
        console.error("Error delete group:", e);
      }
    },

    clearForm() {
      this.group = { id: "", name: "", description: "" };
    },
  },
  watch: {
    size() {
      this.reload();
    },
  },
  mounted() {
    this.getAllDevice();
    // ลบ getTemplateList() ออก เพราะเราไม่ได้ใช้ในหน้า Groups แล้ว
  },
};
</script>

<style scoped>
.table td,
.table th {
  vertical-align: middle;
}
</style>